import content from "./generated/same-mind.json" with { type: "json" };
export type SameMindPrompt = { id: string; version: number; theme: string; question: string; options: string[]; provenance: string; reviewStatus: string; legacyIndex?: number };
export const sameMindContent = content as { contentVersion: string; themeLabels: Record<string, string>; prompts: SameMindPrompt[] };
export const sameMindPrompts = sameMindContent.prompts;
export function unusedSameMindPrompts(input: { usedIds: readonly string[]; historicalIds?: readonly string[]; themes?: readonly string[]; includeUsed?: boolean }) {
  const pool = sameMindPrompts.filter((p) => !input.themes?.length || input.themes.includes(p.theme));
  const used = new Set(input.usedIds);
  const eligible = pool.filter((p) => !used.has(p.id));
  if (input.includeUsed) return eligible;
  const previous = new Set(input.historicalIds ?? []);
  const fresh = eligible.filter((p) => !previous.has(p.id));
  return fresh;
}
